import styled from "styled-components";

export const Container = styled.div`
  width: 300px;
  max-height: 300px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bbb;
  }
  & > div {
    border-bottom: 1px solid #eee;
    line-height: 40px;
    padding: 10px;
    cursor: pointer;
  }
  & > div:hover {
    background: #eee;
  }
`;

export const ContainerTooltip = styled.div`
  max-width: 200px;
  max-height: 200px;
  overflow-y: hidden;
  & ul {
    list-style: circle;
  }
  & li {
    max-width: 200px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #aaa5;
    line-height: 20px;
  }
  & li span:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 20px;
  }
`;
